import React from "react";

/**
 * Embeds a live MarineTraffic map tracking a single vessel by MMSI.
 * Uses MarineTraffic's public iframe embed endpoint — no API key required,
 * shows real AIS position data refreshed by MarineTraffic itself.
 */
export default function VesselTrackingMap({ mmsi, vesselName, height = 360 }) {
  if (!mmsi) {
    return (
      <div
        className="flex items-center justify-center rounded-xl border border-dashed border-slate-300 bg-slate-50 text-sm text-slate-400"
        style={{ height }}
      >
        No MMSI set for this vessel — add one in vessel settings to show live tracking.
      </div>
    );
  }

  const src = `https://www.marinetraffic.com/en/ais/embed/zoom:8/mmsi:${mmsi}/maptype:1`;

  return (
    <div className="overflow-hidden rounded-xl border border-slate-200">
      <iframe
        title={`Live position — ${vesselName || "vessel"}`}
        src={src}
        width="100%"
        height={height}
        style={{ border: 0 }}
        loading="lazy"
      />
      <div className="flex items-center justify-between bg-slate-50 px-3 py-2 text-xs text-slate-500">
        <span>Live AIS position via MarineTraffic</span>
        <a
          href={`https://www.marinetraffic.com/en/ais/details/ships/mmsi:${mmsi}`}
          target="_blank"
          rel="noreferrer"
          className="font-medium text-blue-600 hover:underline"
        >
          Open full tracker →
        </a>
      </div>
    </div>
  );
}
